import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: "'Instrument Sans', system-ui, Arial, sans-serif",
    h1: { fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 700 },
    h2: { fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 700 },
    h3: { fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 700 },
    h4: { fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 700 },
    h5: { fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 700 },
    h6: { fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 700 }
  },
  palette: {
    primary: {
      main: '#1778A8',
      dark: '#0E4F70',
      light: '#5BBCE4',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#17222C',
    },
    error: {
      main: '#B42318',
    },
    background: {
      default: '#F4F7F9',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#17222C',
      secondary: '#5F6B76',
    },
    divider: '#E6ECF0',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          textTransform: 'none',
          fontWeight: 600,
          boxShadow: 'none',
          '&:hover': { boxShadow: 'none' }
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          border: '1px solid #E6ECF0'
        },
      },
      defaultProps: {
        elevation: 0,
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 16
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 99,
          fontWeight: 500
        }
      }
    }
  }
});

export default theme;
